const invoiceType = [
    { value: 31, label: '增值税专用发票-全电票' },
    { value: 32, label: '增值税普通发票-全电票' },
    { value: 1, label: '增值税专用发票-纸质' },
    { value: 2, label: '增值税普通发票-纸质' },
    { value: 4, label: '增值税专用发票-电子' },
    { value: 3, label: '增值税普通发票-电子' },
];

const TaxType = [
    { label: '0%', value: 0 },
    { label: '1%', value: 1 },
    { label: '3%', value: 3 },
    { label: '6%', value: 6 },
    { label: '9%', value: 9 },
    { label: '10%', value: 10 },
    { label: '11%', value: 11 },
    { label: '13%', value: 13 },
    { label: '16%', value: 16 },
    { label: '17%', value: 17 },
];

export default {
    invoiceType,
    TaxType,
};
